const ErrorModal = ({ title, description, message, onClose }) => {
  const body = description || message || 'An unexpected error occurred.';
  return (
    <div
      className="x-dialog for-error"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="err-title"
    >
      <div className="x-dialog-wrapper">
        <div className="x-dialog-form w-form">
          <div className="x-dialog-header">
            <div id="err-title" className="x-dialog-title for-action" style={{ color: '#b71c1c' }}>
              {title || 'Error'}
            </div>
            {onClose && (
              <div className="x-btn-container">
                <a onClick={onClose} className="x-icon-btn for-simple is-close-modal w-button">
                  
                </a>
              </div>
            )}
          </div>
          <div className="x-dialog-body">
            <div className="x-form-wrapper">
              <div className="x-form-row">
                <div className="x-form-col">
                  <p style={{ marginTop: 0 }}>{body}</p>
                </div>
              </div>
              {onClose && (
                <div className="x-form-action" style={{ textAlign: 'right' }}>
                  <button
                    type="button"
                    className="button-primary w-button"
                    onClick={onClose}
                    style={{ background: '#b71c1c' }}
                  >
                    Close
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="x-dialog-overlay" />
      </div>
    </div>
  );
};

export default ErrorModal;
